import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { grammarCheckpointFamilySchema } from '../schemas';

const submitGrammarCheckpointV1DataSchemaDefinition = z.object({
  score: z.number().int().min(0).max(100),
  correctCount: z.number().int().min(0),
  size: z.number().int().min(0),
  families: z.array(grammarCheckpointFamilySchema),
  attemptNumber: z.number().int().min(0),
});

export const submitGrammarCheckpointV1DataSchema: typeof submitGrammarCheckpointV1DataSchemaDefinition =
  submitGrammarCheckpointV1DataSchemaDefinition;

export type ISubmitGrammarCheckpointV1Data = z.infer<typeof submitGrammarCheckpointV1DataSchema>;

export const submitGrammarCheckpointV1ResponseSchema: z.ZodSchema<
  IAPI<ISubmitGrammarCheckpointV1Data>
> = createApiResponseSchema(submitGrammarCheckpointV1DataSchema) as z.ZodSchema<
  IAPI<ISubmitGrammarCheckpointV1Data>
>;

export type ISubmitGrammarCheckpointV1Response = IAPI<ISubmitGrammarCheckpointV1Data>;
